__turbopack_context__.v({
  "activeFilterLabel": "ProductListing-module__oBEqCG__activeFilterLabel",
  "activeFilterRemove": "ProductListing-module__oBEqCG__activeFilterRemove",
  "activeFilterTag": "ProductListing-module__oBEqCG__activeFilterTag",
  "activeFiltersContainer": "ProductListing-module__oBEqCG__activeFiltersContainer",
  "activeFiltersGrid": "ProductListing-module__oBEqCG__activeFiltersGrid",
  "activeFiltersHeader": "ProductListing-module__oBEqCG__activeFiltersHeader",
  "activeFiltersTitle": "ProductListing-module__oBEqCG__activeFiltersTitle",
  "categoryBodyContainer": "ProductListing-module__oBEqCG__categoryBodyContainer",
  "categoryBodyHtml": "ProductListing-module__oBEqCG__categoryBodyHtml",
  "categoryBodyInlineLink": "ProductListing-module__oBEqCG__categoryBodyInlineLink",
  "categoryBodyLinksBlock": "ProductListing-module__oBEqCG__categoryBodyLinksBlock",
  "categoryBodyLinksTitle": "ProductListing-module__oBEqCG__categoryBodyLinksTitle",
  "categoryBodySection": "ProductListing-module__oBEqCG__categoryBodySection",
  "categoryBodyText": "ProductListing-module__oBEqCG__categoryBodyText",
  "categoryBodyTitle": "ProductListing-module__oBEqCG__categoryBodyTitle",
  "categoryChip": "ProductListing-module__oBEqCG__categoryChip",
  "categoryChipIcon": "ProductListing-module__oBEqCG__categoryChipIcon",
  "categoryItem": "ProductListing-module__oBEqCG__categoryItem",
  "categoryItemActive": "ProductListing-module__oBEqCG__categoryItemActive",
  "categoryName": "ProductListing-module__oBEqCG__categoryName",
  "categoryNameActive": "ProductListing-module__oBEqCG__categoryNameActive",
  "categoryScroll": "ProductListing-module__oBEqCG__categoryScroll",
  "checkbox": "ProductListing-module__oBEqCG__checkbox",
  "clearAllButton": "ProductListing-module__oBEqCG__clearAllButton",
  "desktopOnly": "ProductListing-module__oBEqCG__desktopOnly",
  "divider": "ProductListing-module__oBEqCG__divider",
  "filterSearchIcon": "ProductListing-module__oBEqCG__filterSearchIcon",
  "filterSearchInput": "ProductListing-module__oBEqCG__filterSearchInput",
  "filterSearchWrapper": "ProductListing-module__oBEqCG__filterSearchWrapper",
  "filterSidebar": "ProductListing-module__oBEqCG__filterSidebar",
  "formControlLabel": "ProductListing-module__oBEqCG__formControlLabel",
  "formGroup": "ProductListing-module__oBEqCG__formGroup",
  "gridContainer": "ProductListing-module__oBEqCG__gridContainer",
  "introContainer": "ProductListing-module__oBEqCG__introContainer",
  "introText": "ProductListing-module__oBEqCG__introText",
  "itemsPerPageContainer": "ProductListing-module__oBEqCG__itemsPerPageContainer",
  "itemsPerPageLabel": "ProductListing-module__oBEqCG__itemsPerPageLabel",
  "itemsPerPageSelect": "ProductListing-module__oBEqCG__itemsPerPageSelect",
  "loaderContainer": "ProductListing-module__oBEqCG__loaderContainer",
  "mainSection": "ProductListing-module__oBEqCG__mainSection",
  "mobileCategoryArea": "ProductListing-module__oBEqCG__mobileCategoryArea",
  "mobileDrawerBody": "ProductListing-module__oBEqCG__mobileDrawerBody",
  "mobileDrawerClose": "ProductListing-module__oBEqCG__mobileDrawerClose",
  "mobileDrawerHeader": "ProductListing-module__oBEqCG__mobileDrawerHeader",
  "mobileDrawerOverlay": "ProductListing-module__oBEqCG__mobileDrawerOverlay",
  "mobileDrawerPanel": "ProductListing-module__oBEqCG__mobileDrawerPanel",
  "mobileDrawerTitle": "ProductListing-module__oBEqCG__mobileDrawerTitle",
  "mobileFilterButton": "ProductListing-module__oBEqCG__mobileFilterButton",
  "mobileOnly": "ProductListing-module__oBEqCG__mobileOnly",
  "noResults": "ProductListing-module__oBEqCG__noResults",
  "noResultsText": "ProductListing-module__oBEqCG__noResultsText",
  "open": "ProductListing-module__oBEqCG__open",
  "pageContainer": "ProductListing-module__oBEqCG__pageContainer",
  "pagination": "ProductListing-module__oBEqCG__pagination",
  "paginationButton": "ProductListing-module__oBEqCG__paginationButton",
  "paginationButtonActive": "ProductListing-module__oBEqCG__paginationButtonActive",
  "paginationButtonDisabled": "ProductListing-module__oBEqCG__paginationButtonDisabled",
  "paginationContainer": "ProductListing-module__oBEqCG__paginationContainer",
  "paginationEllipsis": "ProductListing-module__oBEqCG__paginationEllipsis",
  "resultsCount": "ProductListing-module__oBEqCG__resultsCount",
  "resultsInfo": "ProductListing-module__oBEqCG__resultsInfo",
  "scrollableContainer": "ProductListing-module__oBEqCG__scrollableContainer",
  "sidebarSection": "ProductListing-module__oBEqCG__sidebarSection",
  "sidebarTitle": "ProductListing-module__oBEqCG__sidebarTitle",
  "sidebarTitleClickable": "ProductListing-module__oBEqCG__sidebarTitleClickable",
  "sliderContainer": "ProductListing-module__oBEqCG__sliderContainer",
  "sliderTrack": "ProductListing-module__oBEqCG__sliderTrack",
});
